module.exports = __webpack_public_path__ + "media/packs/images/collapse-group-icon-5cb3819e115466f9f8a1ba388e1a9424.svg";